import React, {Component} from 'react'

export default class RawHTML extends Component {
  render() {
    return <div className={this.props.className}
      dangerouslySetInnerHTML={{ __html: this.props.children.replace(/\n/g, '<br />').replace(/color/g, "colors:") }} />
  }
}